// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"zm-z","badgeLink":"Am-z","category":"Bm-z"};